if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat([
          'data-trigger-open',
          'data-repeat-open'
        ]);
      }

      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this.triggerOpen = this.dataset.triggerOpen || 'immediately';
        this.repeatOpen = this.dataset.repeatOpen || 'no_repeat';

        window.FoxTheme.DOMready(this.handleOpen.bind(this));
      }

      handleOpen() {
        // Don't automatically open the popup inside Shopify Theme Editor.
        if (Shopify.designMode) return;

        switch (this.triggerOpen) {
          case 'delay':
            setTimeout(() => {
              this.show();
            }, 5000);
            break;

          case 'scroll_down':
            this.triggerAfterScroll(700, this.show.bind(this));
            break;

          case 'immediately':
          default:
            // Open immediately when the page is loaded.
            this.show();
            break;
        }
      }

      triggerAfterScroll(offset = 500, trigger) {
        let opened = false;
        const start = 0;

        const handleScroll = () => {
          const scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;

          if (scrollTop - start > offset && !opened) {
            opened = true;
            trigger();

            window.removeEventListener('scroll', handleScroll);
          }
        };

        window.addEventListener('scroll', handleScroll, {
          passive: true
        });
      }
    }
  );
}